import { useEffect } from 'react';
import { useLocationPicker } from '@ifixit/ui/components/location-provider';
import { OPEN_LOCATION_PICKER_EVENT } from './request-location-picker';

export function OpenLocationPickerListener() {
   const { openPicker } = useLocationPicker();

   useEffect(() => {
      window.addEventListener(OPEN_LOCATION_PICKER_EVENT, openPicker);
      return () => window.removeEventListener(OPEN_LOCATION_PICKER_EVENT, openPicker);
   }, [openPicker]);

   return null;
}
